import inspectorReducers from './reducers';
export { default as inspectorActions } from './actions';
export { default as inspectorSelectors } from './selectors';
export { default as inspectorMiddleware } from './middleware';
export default inspectorReducers;